var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn_home",on:{"click":_vm.goPage}},[_c('img',{attrs:{"src":_vm.imgHost + 'goHome.png?v=' + _vm.$config.OSSVersion}})])}
var staticRenderFns = []

export { render, staticRenderFns }